import { FC } from "react";
import styled from "styled-components";
import { HashLink } from "react-router-hash-link";
import { FormattedMessage, useIntl } from "react-intl";

const Footer: FC = () => {
    const { formatMessage } = useIntl();
    return (
        <StyledFooter>
            <FooterContainer>
                <div>
                    <FooterEmail href='mailto:hello@offsetted.com'>HELLO@OFFSETTED.COM</FooterEmail>
                    <FooterAddress>Stadtdeich 2-4, Hamburg, 20097, DE</FooterAddress>
                    <FooterCopyrightMobile>
                        <ImprintLink to='/imprint'>
                            <FormattedMessage id='footer.imprint' />
                        </ImprintLink>
                        <FormattedMessage id='footer.copyright' />
                    </FooterCopyrightMobile>
                </div>
                <FooterSocial>
                    <FooterSocialLinks>
                        <FooterSocialLink
                            title={formatMessage({
                                id: "footer.linkedin",
                            })}
                            href='https://www.linkedin.com/company/offsetted/'
                        >
                            <svg width='60' height='60'>
                                <use href={`${process.env.PUBLIC_URL}/index/icons.svg#lk`}></use>
                            </svg>
                        </FooterSocialLink>
                    </FooterSocialLinks>
                    <FooterCopyright>
                        {" "}
                        <ImprintLink to='/imprint'>
                            <FormattedMessage id='footer.imprint' />
                        </ImprintLink>{" "}
                        <FormattedMessage id='footer.copyright' />
                    </FooterCopyright>
                </FooterSocial>
            </FooterContainer>
        </StyledFooter>
    );
};

export default Footer;

export const StyledFooter = styled.footer`
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;
    border-top: 1px solid rgb(238, 210, 177);
    @media (max-width: 424px) {
        padding-top: 20px;
        padding-bottom: 20px;
    }
`;

export const FooterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
    @media (max-width: 767px) {
        flex-direction: column-reverse;
    }
`;

export const FooterRight = styled.div``;

export const FooterEmail = styled.a`
    font-weight: 700;
    font-size: 56px;
    line-height: 1.1;
    text-decoration: none;
    display: block;
    margin-bottom: 30px;
    color: rgb(39, 112, 216);
    @media (max-width: 1199px) {
        font-size: calc(20px + (36) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 599px) {
        margin-bottom: 20px;
    }
`;

export const FooterAddress = styled.div`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 300;
    color: #2770d8;
    font-size: 28px;
    font-style: normal;
    @media (max-width: 1199px) {
        font-size: calc(20px + (8) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 767px) {
        margin-bottom: 10px;
    }
`;

export const FooterSocial = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
`;

export const FooterSocialLinks = styled.div`
    display: flex;
    margin-bottom: 20px;
    &:hover {
        opacity: 0.7;
    }
`;

export const FooterSocialLink = styled.a`
    &:not(:last-child) {
        margin-right: 10px;
    }
    &:hover {
        opacity: 0.7;
    }
`;

export const FooterSocialIcon = styled.a``;

export const FooterCopyright = styled.div`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 300;
    font-style: normal;
    font-size: 28px;
    color: #2770d8;
    @media (max-width: 1199px) {
        font-size: calc(20px + (8) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 768px) {
        display: none;
    }
`;

export const FooterCopyrightMobile = styled.div`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 300;
    font-style: normal;
    font-size: calc(20px + (8) * ((100vw - 320px) / (1200 - 320)));
    color: #2770d8;
    @media (min-width: 769px) {
        display: none;
    }
`;

export const ImprintLink = styled(HashLink)`
    text-decoration: none;
    padding-right: 40px;
    color: #2770d8;
    font-size: calc(20px + (8) * ((100vw - 320px) / (1200 - 320))); ;
`;

export const HeaderLink = styled(HashLink)`
    text-decoration: none;
    font-weight: 600;
    padding-right: 40px;
    color: #2770d8;
    font-size: 18px;
    @media (max-width: 1240px) {
        font-size: 2.4vw;
    }
`;
